module.exports = __webpack_public_path__ + "static/media/gateway4.b8f061c2.jpg";